import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import "./index.scss";
import par1 from "../../../assets/images/par1.png";
import par2 from "../../../assets/images/par2.png";
import par3 from "../../../assets/images/par3.png";
import par4 from "../../../assets/images/par4.png";

export const Partenaire = () => {
  const settingsRow1 = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 4, // Nombre d'images visibles en même temps
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    arrows: false, // Direction de droite à gauche
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 768, // En dessous de 768px (mobile)
        settings: {
          slidesToShow: 2, // Affiche 3 drapeaux
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // En dessous de 480px (petit mobile)
        settings: {
          slidesToShow: 1, // Affiche 2 drapeaux
          slidesToScroll: 1,
        },
      },
    ],
  };
  const rows1 = [
    { id: 1, image: par1, alt: " partenaire 1 " },
    { id: 2, image: par2, alt: " partenaire 2" },
    { id: 3, image: par3, alt: "partenaire 3" },
    { id: 4, image: par4, alt: "partenaire 4" },
  ];
  return (
    <div>
      <div className="row ms-0 justify-content-center  gx-0 w-100 ">
        <div className="col-12 col-md-12 mx-auto mt-5 mb-5">
          <Slider {...settingsRow1}>
            {rows1.map((row) => (
              <div key={row.id} className="row-slider3">
                <img
                  src={row.image}
                  alt={row.alt}
                  className="image-hover-effect"
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};
